import { DragDropContext } from 'react-beautiful-dnd';

// Publicly export DragDropContext as DragAndDrop for existing usage (even though this is bleeding third party deps through)
export const DragAndDrop = DragDropContext;
